import { useEffect, useState } from 'react';

const WEEKDAYS = [
    'DOMINGO',
    'SEGUNDA-FEIRA',
    'TERÇA-FEIRA',
    'QUARTA-FEIRA',
    'QUINTA-FEIRA',
    'SEXTA-FEIRA',
    'SÁBADO',
];

const MONTHS = [
    'JANEIRO',
    'FEVEREIRO',
    'MARÇO',
    'ABRIL',
    'MAIO',
    'JUNHO',
    'JULHO',
    'AGOSTO',
    'SETEMBRO',
    'OUTUBRO',
    'NOVEMBRO',
    'DEZEMBRO',
];

const pad = (value) => String(value).padStart(2, '0');

export const formatClock = (date) => (
    `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
);

export const formatLongDate = (date) => (
    `${WEEKDAYS[date.getDay()]}, ${date.getDate()} DE ${MONTHS[date.getMonth()]} DE ${date.getFullYear()}`
);

/**
 * Relógio local atualizado a cada segundo.
 * @returns {{ time: string, dateLabel: string }}
 */
const useLiveClock = () => {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        const tick = () => setNow(new Date());
        const intervalId = window.setInterval(tick, 1000);
        return () => window.clearInterval(intervalId);
    }, []);

    return {
        time: formatClock(now),
        dateLabel: formatLongDate(now),
    };
};

export default useLiveClock;
